export enum SparepartAssemblyActionTypes {
  OPEN_SPAREPART_ASSEMBLY_MODAL = "OPEN_SPAREPART_ASSEMBLY_MODAL",
  CLOSE_SPAREPART_ASSEMBLY_MODAL = "CLOSE_SPAREPART_ASSEMBLY_MODAL",
  CLOSE_AND_SAVE_SPAREPART_ASSEMBLY_MODAL = "CLOSE_AND_SAVE_SPAREPART_ASSEMBLY_MODAL",
  DISABLE_SPAREPART_ASSEMBLY_POSITION_INFO = "DISABLE_SPAREPART_ASSEMBLY_POSITION_INFO",
  SET_SPAREPART_ASSEMBLY_POSITION_INFO = "SET_SPAREPART_ASSEMBLY_POSITION_INFO",
  CLEAR_SPAREPART_ASSEMBLY_POSITION_INFO = "CLEAR_SPAREPART_ASSEMBLY_POSITION_INFO",
  CLEAR_SPAREPART_ASSEMBLY_DATA = "CLEAR_SPAREPART_ASSEMBLY_DATA"
}
